export const NEW_TEAM_MODAL_NAME = 'NewTeamModal'
export const EDIT_TEAM_MODAL_NAME = 'EditTeamModal'
export const ADD_TEAM_MEMBERS_MODAL_NAME = 'AddTeamMembersModal'
export const REMOVE_TEAM_MEMBER_MODAL = 'RemoveTeamMemberModal'
